import { message } from "antd";
import { useEffect, useRef, useState } from "react";
import { updateAssistant } from "../../../service";
import { Input } from "V2.0/common/input";

function AssistantRenameInline(props) {
  const { assistantName, assistantId, workspaceId, onUpdatedName, onDone } =
    props;

  const [name, setName] = useState(assistantName);
  const [error, setError] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  const handleRename = async () => {
    if (error || name === assistantName) {
      onDone();
      return;
    }

    onDone();

    try {
      const response = await updateAssistant({
        projectId: workspaceId,
        assistantId,
        payload: {
          name,
        },
      });

      if (response.status === 200) {
        message.success("Name Updated");
        onUpdatedName(name);
        onDone();
      }
    } catch (e) {
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to update assistant"
      );
    }
  };

  return (
    <Input
      ref={ref}
      className="w-24"
      type="text"
      value={name}
      onBlur={handleRename}
      onChange={(e) => {
        setName(e.target.value);

        if (e.target.value.trim() === "") {
          setError(true);
          return;
        }

        if (error) {
          setError(false);
          return;
        }
      }}
      invalid={error}
    />
  );
}

export default AssistantRenameInline;
